/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListinoDTO
 */
export interface ListinoDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoDTO
     */
    idListino?: number;
    /**
     * 
     * @type {number}
     * @memberof ListinoDTO
     */
    idFiliera?: number;
    /**
     * 
     * @type {string}
     * @memberof ListinoDTO
     */
    cliente?: string | null;
}

/**
 * Check if a given object implements the ListinoDTO interface.
 */
export function instanceOfListinoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoDTOFromJSON(json: any): ListinoDTO {
    return ListinoDTOFromJSONTyped(json, false);
}

export function ListinoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idListino': !exists(json, 'idListino') ? undefined : json['idListino'],
        'idFiliera': !exists(json, 'idFiliera') ? undefined : json['idFiliera'],
        'cliente': !exists(json, 'cliente') ? undefined : json['cliente'],
    };
}

export function ListinoDTOToJSON(value?: ListinoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idListino': value.idListino,
        'idFiliera': value.idFiliera,
        'cliente': value.cliente,
    };
}

